import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'spinner'];
  static values = {
    autoResetOnSubmit: {
      type: Boolean,
      default: false,
    },
    keepSrc: {
      type: Boolean,
      default: true,
    },
  };

  connect() {
    this.originalSrc = undefined;
    if (this.hasContentTarget && this.keepSrcValue) {
      this.originalSrc = this.contentTarget.getAttribute('src');
    }
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this);
    // Listen for form submissions that bubble up from forms within this element
    this.element.addEventListener('turbo:submit-end', this.boundHandleSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.boundHandleSubmitEnd);
  }

  handleSubmitEnd(event) {
    // Reset the modal after successful form submission if auto-reset is enabled
    if (!this.autoResetOnSubmitValue) {
      return;
    }

    // Check if the form is within our element and if the response was successful
    const form = event.target.closest('form');
    if (form && this.element.contains(form)) {
      const fetchResponse = event.detail?.fetchResponse;
      if (fetchResponse && fetchResponse.succeeded) {
        this.reset();
      }
    }
  }

  reset() {
    if (this.hasContentTarget) {
      // Clears or resets the content of the modal
      this.contentTarget.innerHTML = '';
      this.contentTarget.src = this.originalSrc;
      if (this.hasSpinnerTarget) {
        this.contentTarget.innerHTML = this.spinnerTarget.innerHTML;
        const spinnerElement = this.contentTarget.querySelector('.hidden');
        if (spinnerElement) {
          spinnerElement.classList.remove('hidden');
        }
      }
      this.contentTarget.reload();
    }
  }
}
